let toggleThumbsButton = document.querySelector('#toggleThumbs');
let thumbsContainer = document.querySelector('#collapseThumbs');

if (toggleThumbsButton) {


	toggleThumbsButton.addEventListener('click', (e) => {
		if (thumbsContainer) {
			thumbsContainer.classList.toggle('m-product-thumb-container-collapse');
		}
	});
}
